<nb-layout>
  <nb-layout-column>
    <div class="public-shared-container" *ngIf="!isError">
      <nb-card>
        <nb-card-body>
          <div class="shared-files">
            <h2 class="sub-title">
              {{ title }}
            </h2>

            <div class="require-password-form" *ngIf="requirePassword">
              <p class="introduction">
                The link you're trying to access is password protected. 
                Please input password
              </p>

              <form
                aria-labelledby="title"
                class="form-horizontal"
                #requirePasswordForm="ngForm"
                autocomplete="off"
                novalidate
                (submit)="
                  submitPassword(
                    requirePasswordForm.value,
                    requirePasswordForm.valid
                  )
                "
              >
                <div class="row">
                  <div class="col-lg-10 col-md-10 col-sm-12">
                    <div
                      class="form-control-group"
                      [ngClass]="{
                        'has-error': !password.valid && password.touched,
                        'has-success': password.valid && password.touched
                      }"
                    >
                      <span class="label-with-link">
                        <label for="input-password" class="label">
                          Password :
                        </label>
                      </span>
                      <input
                        nbinput
                        fullwidth
                        name="password"
                        type="password"
                        id="password"
                        placeholder="Password"
                        fieldsize="medium"
                        class="input-full-width size-medium status-basic shape-rectangle nb-transition"
                        required
                        ngModel
                        #password="ngModel"
                      />
                      <div
                        class="alert alert-danger"
                        *ngIf="
                          (submitted && !password.valid) ||
                          (password.touched && !password.valid)
                        "
                        style="position: absolute; z-index: 100"
                      >
                        <div>
                          Password is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-12">
                    <button
                      nbButton
                      matRipple
                      hero
                      fullwidth
                      status="info"
                      size="large"
                      aria-disabled="false"
                      tabindex="-1"
                      class="appearance-filled full-width size-large shape-rectangle status-primary nb-transition"
                      type="submit"
                      [disabled]="requirePasswordForm.invalid"
                    >
                      Enter
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div class="case-details-section" *ngIf="caseDetail && totalSharedFiles > 0">
              <div class="row">
                <div class="col-lg-2 col-md-2 col-2 folder-icon text-center">
                  <i class="fa-light fa-folder"></i>
                </div>
                <div class="col-lg-10 col-md-10 col-10 case-details text-left">
                  <div class="row">
                    <div class="col-lg-12">
                      <h6>Title: {{ caseDetail.title }}</h6>
                    </div>
                    <div class="col-lg-12">
                      <h6>Tag: {{ caseDetail.tag }} </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="shared-files-list" *ngIf="totalSharedFiles > 0">
              <div class="table-responsive">
                <table class="table table-borderless fix-height">
                  <thead>
                    <tr>
                      <th class="th-sm th_checkbox">
                        <nb-checkbox
                          #chk
                          (checkedChange)="onToggleSelectedChang($event)"
                          [disabled]="!allowDownload"
                          name="selectAll"
                          id="selectAll"
                          ngModel
                          [(ngModel)]="checkAllControl"
                        >
                        </nb-checkbox>
                      </th>
                      <th class="th-sm th_type">TYPE</th>
                      <th class="th-lg th_title">TITLE</th>
                      <th class="th-lg th_upload_by">UPLOAD BY</th>
                      <th class="th-lg th_upload_date">UPLOADED DATE</th>
                      <th class="th-lg th_size">SIZE</th>
                      <th class="th-lg th_action">ACTION</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td colspan="7">
                        <table class="table table-level-2">
                          <tbody>
                            <tr *ngFor="let file of dataCheckboxList">
                              <td class="td_checkbox">
                                <nb-checkbox
                                  #fileItem
                                  (checkedChange)="
                                    onSelectedChang($event, file.id)
                                  "
                                  name="fileItem"
                                  [checked]="file.isSelected"
                                  [disabled]="!allowDownload"
                                >
                                </nb-checkbox>
                              </td>
                              <td class="td_type">
                                <a (click)="previewFile(file)">
                                  <img
                                    class="img-thumbnail"
                                    title=""
                                    src="assets/images/{{
                                      file.file_type | lowercase
                                    }}.png"
                                  />
                                </a>
                              </td>
                              <td class="td_title">{{ file.title }}</td>
                              <td class="td_upload_by">{{ file.upload_by }}</td>
                              <td class="td_upload_date">
                                {{
                                  file.uploaded_date | date : "MMM-dd-YYYY HH:mm:ss"
                                }}
                              </td>
                              <td class="td_size">{{ formatBytes(file.file_size,2) }}</td>
                              <td class="td_action">
                                <i
                                  class="fa-solid fa-cloud-arrow-down disabled"
                                  title="Download"
                                  *ngIf="!allowDownload"
                                ></i>
                                <i
                                  class="fa-solid fa-cloud-arrow-down"
                                  title="Download"
                                  *ngIf="allowDownload"
                                  (click)="onDownloadFile($event, file.prev_token)"
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="comments-row row" *ngIf="shareDescription">
                <div class="col-lg-12">
                  <h3>Comments</h3>
                  <p *ngIf="shareDescription.length <= 600">{{ shareDescription }}</p>
                  <p *ngIf="shareDescription.length > 600">{{ shareDescription | slice : 0 : 600 }}...</p>
                </div>
              </div>
              <div class="buttons-row row">
                <div class="col-lg-12">
                  <button
                    nbButton
                    matRipple
                    hero
                    status="info"
                    size="large"
                    aria-disabled="false"
                    tabindex="-1"
                    class="appearance-filled size-large shape-rectangle status-primary nb-transition"
                    [disabled]="!allowDownload || totalSelectedFiles === 0"
                    type="button"
                    (click)="onDownloadAll()"
                  >
                    Download All
                  </button>
                </div>
              </div>
            </div>

            <div class="alert-box-custom-warning" *ngIf="isSharedDataAvaliableBox">
              <div class="alert-box-content-warning">
                <div class="message">
                  <span class="text">
                    {{messages.no_data}}
                  </span>
                </div>
              </div>
            </div>

            <div class="alert-box-custom" *ngIf="isSharedExpired">
              <div class="alert-box-content">
                <div class="message">
                  <span class="text">
                    {{messages.expired}}
                    {{ expiryDate | date : "MMM dd, YYYY" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="public-shared-container" *ngIf="isError">
      <nb-card>
        <nb-card-body>
          <div class="shared-files">
            <h2 class="sub-title">
              {{ title }}
            </h2>

              <div class="alert-box-custom">
                <div class="alert-box-content">
                  <div class="message">
                    <span class="text">
                      {{messages.error}}
                    </span>
                  </div>
                </div>
              </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </nb-layout-column>
</nb-layout> 

<loading *ngIf="loading" message="{{ loadingMessage }}"></loading>
